document.addEventListener('click',function(e){
  var t=e.target.closest('[data-thumb]');
  if(t){var i=t.dataset.thumb;var main=document.getElementById('mainImg');if(main)main.src=t.dataset.src;
    document.querySelectorAll('[data-thumb]').forEach(x=>x.classList.remove('active'));t.classList.add('active');}
  var v=e.target.closest('[data-variant]');
  if(v){document.querySelectorAll('[data-variant]').forEach(x=>x.classList.remove('active'));v.classList.add('active');
    document.getElementById('pPrice').textContent=v.dataset.price;
    document.getElementById('pCompare').textContent=v.dataset.compare;
    document.getElementById('pPix').textContent=v.dataset.pix;
    document.getElementById('pInst').textContent=v.dataset.installment;}
  var q=e.target.closest('[data-qty]');
  if(q){var s=document.getElementById('qtyVal');var n=parseInt(s.textContent,10);
    n = q.dataset.qty==='+' ? n+1 : Math.max(1,n-1); s.textContent=n;}
});
